<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-29 20:30:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/OrderProductDet/index.vue
-->
<template>
  <!-- 订单详情订单信息 -->
  <div class="det_product">
    <div
      class="order_id font12 font_weight500 colo087 line_height_20 text_left"
    >
      <div>
        <span class="det_det_title">订单编号：</span>{{ getUserOrder.orderSn }}
      </div>
      <div
        v-clipboard:copy="getUserOrder.orderSn"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        class="font_weight400 copy_id"
      >
        复制
      </div>
    </div>
    <div
      v-if="getUserOrder.gmtCreate"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">下单时间：</span
      >{{ getUserOrder.gmtCreate | dateFormatterJava("YYYY-MM-DD HH:mm:ss") }}
    </div>
    <!-- <div
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">发货仓：</span>杭州保税仓
    </div> -->
    <div
      v-if="getUserOrder.payMethod"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">支付方式：</span>{{ getUserOrder.payMethod }}
    </div>
    <div
      v-if="getUserOrder.payReference"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">支付单号：</span
      >{{ getUserOrder.payReference }}
    </div>
    <div
      v-if="getUserOrder.payTime"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">支付时间：</span
      >{{ getUserOrder.payTime | dateFormatterJava("YYYY-MM-DD HH:mm:ss") }}
    </div>
    <div
      v-if="getUserOrder.deliveryPlanTime"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">预计发货日：</span
      >{{ getUserOrder.deliveryPlanTime | dateFormatterJava("YYYY-MM-DD") }}
    </div>
    <!-- <div
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">配送方式：</span>普通快递
    </div> -->
    <div
      v-if="getUserOrder.userMessage"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">买家留言：</span
      >{{ getUserOrder.userMessage }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  },
  methods: {
    onCopy() {
      this.$toast("订单号已复制到剪贴板！");
    },
    onError() {
      this.$toast("复制失败，请重试！");
    }
  }
};
</script>

<style lang="less" scoped>
.det_product {
  background: #fff;
  box-shadow: inset 0px 15px 12px -15px #f2f0f0;
  padding: 18px 12px 0;
  .order_id {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-bottom: 12px;
    .copy_id {
      padding: 0 8px;
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.38);
    }
  }
  .det_item {
    padding-bottom: 12px;
  }
  .det_det_title {
    width: 84px;
    display: inline-block;
  }
}
</style>
